import React from "react";

import styled from "@emotion/styled";
import {
  desktopQuery,
  laptopQuery,
  mobileQuery,
  tabletQuery,
} from "../utils/mediaqueries";

import TabBar from "./tabBar/TabBar";
import TabBarItem from "./TabbarItem";

const NavMenuWrapper = styled.div(
  {
    position: "fixed",
    zIndex: 2,

    [mobileQuery]: {
      width: "100%",
      bottom: 0,
    },

    [tabletQuery]: {
      width: "100%",
      bottom: 0,
    },

    [laptopQuery]: {
      width: "6.5%",
      left: 0,
    },

    [desktopQuery]: {
      width: "6.5%",
      left: 0,
    },
  },
  (props) => ({
    [mobileQuery]: {
      display: props.hide ? "none" : "block",
    },

    [tabletQuery]: {
      display: props.hide ? "none" : "block",
    },
  }),
);

const NavMenu = ({ hide, uri }) => {
  const highlight = uri ? uri.includes("univerzita") : false;
  return (
    <NavMenuWrapper hide={hide}>
      <TabBar>
        <TabBarItem
          highlight={highlight}
          label='Univerzita'
          icon='university'
          to='/univerzita'
        />
        <TabBarItem label='Studium' icon='user-graduate' to='/studium' />
        <TabBarItem label='Město' icon='city' to='/mesto' />
        <TabBarItem label='Navštiv nás' icon='calendar' to='/navstiv-nas' />
      </TabBar>
    </NavMenuWrapper>
  );
};

export default NavMenu;
